module.exports = __webpack_public_path__ + "resources/img/img_global_network.535ec0bb1a6f021ec632fbb145b97635.png";